import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

export const MY_ITEMS = "My items";

export const GROUP_ORDER_MENU_DEEPLINK = "swiggy://menu?restaurant_id={0}&group_cart_id={1}&host_name={2}";

export const USER_NAME_WITH_HOST = "{0} (Host)";

export const NR_PAGE_ERROR_TYPES = {
    EMPTY_RESPONSE: "empty_response",
    CUSTOM_API_ERROR_CODE: "custom_api_error_code",
};

export const GUEST_LOCKED_STATUS_BANNER_PROPS = {
    title: "Cart locked and loaded!",
    subtitle: "Host is placing the order now :)",
    leftAssetCloudinaryId: "portal/testing/group-cart/LockedGroupCartIcon.png",
    bgColor: "rain_Sub" as keyof IColors,
};
export const GUEST_UNLOCKED_STATUS_BANNER_PROPS = {
    title: "Host calls the shots! ",
    subtitle: "Host can apply final discounts and place order at checkout.",
    bgColor: "border_Tertiary" as keyof IColors,
};

export const HOST_BANNER_PROPS = {
    title: "You call the shots!",
    subtitle: "You can apply discounts and place order at checkout.",
    bgColor: "border_Tertiary" as keyof IColors,
};

export const HOST_UNLOCKING_TOAST_MESSAGE =
    "Hey Party Host! Changes made at checkout don't apply here. Your cart has been reset";
